// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useContext, ComponentProps } from 'react';
import { useIntl } from 'react-intl';
import CommonContext from '../../contexts/CommonContext';

interface LevelProps extends ComponentProps<any> {
  id: number;
  lang?: string;
}

const Level: React.FC<LevelProps> = ({ id, lang }) => {
  const { levels } = useContext(CommonContext);
  const level = levels.find(level => level.id === id);
  const intl = useIntl();

  let text = '';
  switch (level?.level) {
    case '100':
      text = intl.formatMessage({ id: 'Z002' });
      break;
    case '200':
      text = intl.formatMessage({ id: 'Z003' });
      break;
    case '300':
      text = intl.formatMessage({ id: 'Z004' });
      break;
    case '400':
      text = intl.formatMessage({ id: 'Z005' });
      break;
  }

  return <>{text}</>
}

export { Level as default }
;
